import { Container, Drawer, Flex, Group, Title } from '@mantine/core';
import { DrawerOptions, OpenConfirmModal, useGeneralDrawer } from 'hooks/useGeneralDrawer';
import { PropsWithChildren, createContext } from 'react';
import { Z_INDEX_VALUES } from 'utils/general';

interface DrawerContextType {
  openDrawer: (options: DrawerOptions) => void;
  closeDrawer: (showDiscardModal?: boolean) => void;
  setDiscardModal: (confirmModal?: OpenConfirmModal) => void;
}

const DrawerContext = createContext<DrawerContextType | undefined>(undefined);
DrawerContext.displayName = 'Drawer';

const DrawerProvider = ({ children }: PropsWithChildren) => {
  const { isDrawerOpen, closeDrawer, openDrawer, size, content, lockScroll, title, actions, setDiscardModal } =
    useGeneralDrawer();

  return (
    <DrawerContext.Provider value={{ openDrawer, closeDrawer, setDiscardModal }}>
      <Drawer
        size={size}
        opened={isDrawerOpen}
        onClose={closeDrawer}
        position={'right'}
        lockScroll={lockScroll}
        zIndex={Z_INDEX_VALUES.drawer}
      >
        <Container fluid>
          <Flex justify={'space-between'}>
            {title && (
              <Title order={3} mb={'lg'} mt={'xs'} data-testid={'drawer-title'}>
                {title}
              </Title>
            )}
            {actions && (
              <Group mb={'xl'} mt={'xs'}>
                {actions}
              </Group>
            )}
          </Flex>
          {content}
        </Container>
      </Drawer>
      {children}
    </DrawerContext.Provider>
  );
};

export { DrawerContext, DrawerProvider };
